import { FC } from 'react';

import './Footer.scss';

const Footer: FC = () => {
    return (
        <footer className="Footer" data-testid="Footer">
            <p className="footer-left">
                © <b>Donna Cegonha</b>
            </p>
            <p className="footer-right">
                Desenvolvido por: Mariano Desenvolvimento LTDA
            </p>
        </footer>
    );
};

export default Footer;